import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import CartMain from './CartMain';
import Footer from '../../components/Footer';

const Cart = () => {
  return (
    <>
      <HeaderSeven />

      <CartMain />

      <Footer />
    </>
  );
};

export default Cart;
